import React from "react";
import ContractingStepConfiguration from "features/contracting/models/ContractingStepConfiguration";
import { ContractingSummariesMap } from "./ContractingSummariesMap";
import ContractingSummaryHeader from "./ContractingSummaryHeader";
import { ContractingDTO } from "features/contracting/dtos/ContractingDTO";
import { ContractingConfigurationDTO } from "features/contracting/dtos/ContractingConfigurationDTO";

type Props = {
  contracting: ContractingDTO;
  steps: ContractingStepConfiguration[];
  configuration: ContractingConfigurationDTO;
  disableEdit?: boolean;
  skipOverview?: boolean;
};

const ContractingSummary = ({
  contracting,
  steps,
  configuration,
  disableEdit = false,
  skipOverview = true,
}: Props) => {
  // sub-renders
  const renderSummaries = (): JSX.Element[] => {
    let result: JSX.Element[] = [];

    for (const step of steps) {
      if (skipOverview && step.component === "overview") {
        continue;
      }

      const Summary = ContractingSummariesMap[step.component];

      if (Summary !== undefined) {
        result.push(
          <section key={step.component}>
            <ContractingSummaryHeader
              titleCode={step.title}
              stepRoute={!disableEdit ? step.route : undefined}
            />
            <Summary
              contracting={contracting}
              configuration={configuration}
              step={step}
            />
          </section>
        );
      } else {
        console.warn(`Summary for type '${step.component}' doesn't exists.`);
      }
    }

    return result;
  };

  // render
  return <>{renderSummaries()}</>;
};

export default ContractingSummary;
